import * as React from 'react';
import type { SVGProps } from 'react';
const SvgErrorFullGray = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8}
      fill="var(--color-content-status-neutral-secondary)"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      fillRule="evenodd"
      d="M13.105 7.842a.493.493 0 1 0-.697-.697l-2.283 2.282-2.283-2.282a.493.493 0 0 0-.697.697l2.282 2.283-2.282 2.283a.493.493 0 0 0 .697.697l2.283-2.282 2.283 2.282a.493.493 0 1 0 .697-.697l-2.282-2.283z"
      clipRule="evenodd"
    />
    <path
      fill="var(--color-content-inverted-base-primary)"
      fillRule="evenodd"
      d="M12.196 6.933a.793.793 0 1 1 1.122 1.122l-2.07 2.07 2.07 2.07a.793.793 0 1 1-1.122 1.123l-2.071-2.07-2.07 2.07a.793.793 0 1 1-1.123-1.122l2.071-2.07-2.07-2.071a.793.793 0 0 1 1.121-1.122l2.071 2.07zm-2.071 2.494L7.842 7.145a.493.493 0 1 0-.697.698l2.282 2.282-2.282 2.283a.493.493 0 0 0 .697.698l2.283-2.283 2.283 2.283a.493.493 0 1 0 .697-.698l-2.282-2.283 2.282-2.282a.493.493 0 1 0-.697-.698z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgErrorFullGray;
